export class FileUpload {
  key: string;
  name: string;
  url: string;
  file: File;
  guid: string;

  constructor(file: File) {
    this.file = file;
  }
}
